import tvtApi from '../services/tvt-api';

export const RESET_ERROR = 'RESET_ERROR';
export const CHECK_HEALTH_STATUS = 'CHECK_HEALTH_STATUS';
export const DISPLAY_DOWNTIME = 'DISPLAY_DOWNTIME';

export const resetError = () => ({ type: RESET_ERROR });

export const checkHealthStatus = () => async (dispatch, getState) => {
  const {
    healthy,
    messages,
    success,
    error
  } = await tvtApi.checkHealthStatus();
  const storage = localStorage.getItem('downtime');
  const readMessages = storage ? JSON.parse(storage) : [];
  const unreadMessages = (messages || []).filter(
    m => !readMessages.includes(m.uuid)
  );
  if (success && !healthy && unreadMessages.length > 0) {
    return dispatch({ type: DISPLAY_DOWNTIME, messages: unreadMessages });
  }

  if (!success) {
    console.log(error);
  }

  return dispatch({ type: CHECK_HEALTH_STATUS, healthy, error });
};
